import { useQuery } from '@tanstack/vue-query'
import { getUtilities } from '@/api/utilities/utilities'

export function useUtilities() {
  return useQuery({
    queryKey: ['utilities'],
    queryFn: () => getUtilities()
  })
}
